interface Props {
  size?: number;
  color?: string;
}

const PencilIcon = (props: Props) => {
  const { color = '#000', size = 20 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9.445 16.688h8.5m-6.5-14-8.999 8.998c-.659.659-1.179 1.458-1.337 2.376-.16.927-.213 2.077.335 2.626.549.548 1.7.495 2.626.335.918-.158 1.717-.678 2.376-1.337l8.998-8.998m-4-4s3-3 5-1-1 5-1 5m-4-4 4 4"
      ></path>
    </svg>
  );
};

export default PencilIcon;
